import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";

import { ALERT_DEFAULT_PROPS } from "@organisms/alert/config";

import type { IAlertStore } from "@organisms/alert/types";

export const useAlertStore = create<IAlertStore>()(
  subscribeWithSelector(
    devtools((set) => ({
      alertProps: ALERT_DEFAULT_PROPS,
      setAlertProps: (data) => {
        set({ alertProps: data });
      },
      reset: () => {
        set({ alertProps: ALERT_DEFAULT_PROPS });
      },
    })),
  ),
);
